var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectingRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.93 16.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-width: .93px;\n      }\n\n      .cls-2 {\n        stroke-width: .93px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.47.47H.47v16h16V.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.47,
    y1: 6.57,
    x2: 8.47,
    y2: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.47,
    y1: 16.15,
    x2: 8.47,
    y2: 10.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "11.25 6.97 12.75 8.47 11.25 9.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "5.69 6.97 4.19 8.47 5.68 9.96"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingRooms);
export default __webpack_public_path__ + "static/media/connecting-rooms.befce7603dbbac30c36554c739f0d0fd.svg";
export { ForwardRef as ReactComponent };